import { AxiosError } from 'axios'
import { QueryFunctionContext, useQuery, UseQueryOptions } from 'react-query'

import { type Risk } from 'components/support/risks/risk-form-utils'
import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { getEndpointWithParams } from 'queries/queries-utils'
import { testSuitesQueryKeys } from 'queries/test-suites/query-keys'

export function fetchTestSuitesDetectedRisks({
  queryKey: [baseUrl, params]
}: QueryFunctionContext<ReturnType<typeof testSuitesQueryKeys.detectedRisks>>) {
  const endpointWithParams = getEndpointWithParams(baseUrl, params)
  return fetchQueryData(endpointWithParams)
}

export function useGetTestSuitesDetectedRisks(
  queryOptions?: Omit<
    UseQueryOptions<Risk[], AxiosError>,
    'queryKey' | 'queryFn'
  >
) {
  const { currentTeamId } = useAuth()

  return useQuery({
    ...queryOptions,
    queryFn: fetchTestSuitesDetectedRisks,
    queryKey: testSuitesQueryKeys.detectedRisks({
      teamId: currentTeamId
    })
  })
}
